import React, { Component } from "react";
import playIcon from '../../images/video_play_btn.png'
import linkIcon from '../../images/link.png'
import pdfIcon from '../../images/PDF_file_icon.svg'
class UserVideoCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videoid: '',
            isPdfAvailable: false,
        }
    }
    componentDidMount() {
        this.getVideoId()
        this.handleVideoPlay = this.handleVideoPlay.bind(this)
        const { videoData } = this.props;
        if (videoData?.mediaType === 'application/pdf' && videoData.mediaBase64) {
            fetch(videoData.mediaBase64, { method: 'HEAD' })
                .then((res) => {
                    if (res.ok) {
                        this.setState({ isPdfAvailable: true });
                    }
                })
                .catch(() => {
                    this.setState({ isPdfAvailable: false });
                });
        }
    }
    getVideoId() {
        if (this.props.videoData.mediaLink != undefined && this.props.videoData.mediaLink !== '') {
            //const urlParams = new URL(this.props.videoData.mediaLink).searchParams;
            //const videoId = urlParams.get('v');
            //this.setState({ videoid: videoId });
            const videoId = this.props.videoData.mediaLink.split('v=')[1];
            //const videoId = urlParams.get('v');
            this.setState({ videoid: videoId });
        }
    }
    handleVideoPlay() {
        const videotitle = this.props.videoData ? this.props.videoData.mediaTitle : ''
        this.props.showVideoModal()
        this.props.getVideoId(this.state.videoid, videotitle)
    }
    handleImageOpen(base64Data, mimeType) {
        window.open(window.location.origin + base64Data, '_blank');
    }
    render() {
        return (
            <div className="video-card" onClick={() => {
                this.props.videoData?.mediaBase64 ? this.handleImageOpen(this.props.videoData?.mediaBase64, this.props.videoData?.mediaType) : this.handleVideoPlay()
            }}>
                {
                    this.props.videoData ? <>
                        <div className="video-image">
                            {this.props.videoData?.mediaType !== 'application/pdf' ? <img src={this.props.videoData?.mediaBase64 ? this.props.videoData.mediaBase64 : `https://img.youtube.com/vi/${this.state.videoid}/0.jpg`} alt="" className="video-thumb" />
                                : this.state.isPdfAvailable ? <iframe src={this.props.videoData.mediaBase64}
                                    width="100%"
                                    height="100%">
                                </iframe> : <p style={{ textAlign: 'center', position: 'absolute', bottom: '10px', width: '100%', fontWeight: '500' }}>PDF file not found.</p>}
                            <span className="play-icon"><img src={this.props.videoData?.mediaBase64 ? this.props.videoData?.mediaType !== 'application/pdf' ? linkIcon : pdfIcon : playIcon} alt="Play" /></span>
                        </div>
                        <h3>{this.props.videoData.mediaTitle && this.props.videoData.mediaTitle.substr(0, 35)} {this.props.videoData.mediaTitle && this.props.videoData.mediaTitle.length > 35 ? "\u2026" : ""}</h3>
                    </> : null
                }
            </div>
        )
    }
}
export default UserVideoCard;